import { companiesWorkspaceRateLimitsDataTable } from "@dashboardApi/apis/companiesWorkspaceRateLimitsDataTable";

import type { AllRouteEndpoints } from "../routeTypes";
export const companiesWorkspaceRateLimitsDeleteCacheKeys: AllRouteEndpoints[] = [
  companiesWorkspaceRateLimitsDataTable,
];
